import { useState } from 'react'
import { Link } from 'react-router-dom'
import { Button } from '@/components/ui/button'
import { Star, Calendar, Quote, ThumbsUp, Filter } from 'lucide-react'
import { Header } from '@/components/Header'
import { Footer } from '@/components/Footer'
import drAishwaryaImage from '@/assets/aishwarya_1.jpg'
import '@/styles/animations.css'

const testimonials = [
  {
    id: 1,
    name: 'Varun Kumar',
    rating: 5,
    date: '47 weeks ago',
    review: "I've been under the care of Dr. Aishwarya at SRI SAI SABARI DENTAL CLINIC for the past two years, and I can't express how satisfied I am with the treatment. Her expertise, gentle approach, and genuine concern for patient comfort make every visit a positive experience. The clinic is always clean, and the staff is professional and friendly. I highly recommend Dr. Aishwarya for anyone seeking quality dental care.",
    treatment: 'General Dental Care',
    verified: true,
    featured: true
  },
  {
    id: 2,
    name: 'Uthra Bharathi',
    rating: 5,
    date: '15 Jul 2024',
    review: "Oh my god!!!! I really can't believe I'm done with my dental treatment 😅😅 from my childhood I'm so scared of dentist but Dr. Aishwarya made me feel so comfortable. She's very gentle and explains everything clearly. The entire staff is wonderful and the clinic is very clean. Highly recommend for anyone who has dental anxiety like me!",
    treatment: 'Dental Anxiety Treatment',
    verified: true,
    featured: true
  },
  {
    id: 3,
    name: 'Sathiya Venkatesan',
    rating: 5,
    date: '18 Apr 2023',
    review: "I done a root canal treatment here and had a very nice experience. If you people have any discomfort or problem with your dental problems do reach out Dr. Aishwarya She is doing a great job. The treatment was painless and she explained each step clearly. Thank you doctor!",
    treatment: 'Root Canal Treatment',
    verified: true,
    featured: true
  },
  {
    id: 4,
    name: 'Bragadeesh S',
    rating: 5,
    date: '1 Jun 2022',
    review: "I was extremely nervous about having my tooth treated, but my worrying was a waste of time. From the moment I entered, Dr. Aishwarya made me feel at ease. The treatment was completely painless and the results exceeded my expectations. Her gentle approach and professional expertise are truly remarkable.",
    treatment: 'Dental Treatment',
    verified: true,
    featured: false
  },
  {
    id: 5,
    name: 'Niranjan Indra',
    rating: 5,
    date: '7 Jun 2022',
    review: "Dr. Aishwarya is warm, personable, and made me feel extremely cared for throughout my time with them. It's clear that she genuinely cares about her patients and takes the time to explain everything thoroughly. The clinic is modern and clean, and the entire experience was excellent.",
    treatment: 'General Consultation',
    verified: true,
    featured: false
  },
  {
    id: 6,
    name: 'Santhoshkumar Thiruvengadam',
    rating: 5,
    date: '20 Dec 2021',
    review: "Hello All. Have visited Sri Sai Sabari dental clinic, Dr. Aishwarya is extremely kind and gives quality treatment with reasonable pricing. She explains the procedures clearly and ensures patient comfort throughout. The clinic maintains high hygiene standards. Highly recommended!",
    treatment: 'Dental Treatment',
    verified: true,
    featured: false
  },
  {
    id: 7,
    name: 'Meenakshisundaram Tv',
    rating: 5,
    date: '27 Aug 2021',
    review: "Pleasing and friendly. Painless and fast in extracting my tooth. Though young handles as an experienced dentist. Dr. Aishwarya's skill and gentle touch made what I thought would be a difficult procedure completely comfortable. Excellent service!",
    treatment: 'Tooth Extraction',
    verified: true,
    featured: false
  },
  {
    id: 8,
    name: 'Bharathi V',
    rating: 5,
    date: '24 May 2021',
    review: "Visited the clinic last week as I had severe tooth pain. Best dental clinic, young & energetic dentist. The way she treated me was excellent. She explained everything clearly and the treatment was completely painless. Very satisfied with the service and would definitely recommend to others.",
    treatment: 'Emergency Treatment',
    verified: true,
    featured: false
  },
  {
    id: 9,
    name: 'Venkataraman Subramanian',
    rating: 5,
    date: '24 May 2021',
    review: "Thankful to you for providing treatment in this pandemic. So kind of you, the best dentist I have seen so far. Had a safe and hygienic treatment. Dr. Aishwarya maintained all safety protocols while providing excellent care. Truly appreciate the dedication during challenging times.",
    treatment: 'Pandemic Care',
    verified: true,
    featured: false
  },
  {
    id: 10,
    name: 'Krishna Das',
    rating: 5,
    date: '20 Dec 2020',
    review: "One of the best dental clinic. Best treatment very low consultant fees. Dr. Aishwarya provides excellent value for money while maintaining high quality standards. The treatment was thorough and the pricing is very reasonable. Highly recommend for quality dental care at affordable prices.",
    treatment: 'General Treatment',
    verified: true,
    featured: false
  },
  {
    id: 11,
    name: 'Ajay Sathya',
    rating: 5,
    date: '18 Sept 2020',
    review: "Very nice and experienced professional with reasonable rates. One of the best clinics in madipakkam 👌 Dr. Aishwarya combines expertise with affordability, making quality dental care accessible to everyone. The clinic is well-maintained and the service is excellent.",
    treatment: 'General Consultation',
    verified: true,
    featured: false
  },
  {
    id: 12,
    name: 'Vatsans Gallery',
    rating: 5,
    date: '10 Jul 2020',
    review: "Good that they removed my teeth without any pain, the doctor is very well versed with what she does and cares for the patient with utmost care. Thank you so much Dr. Aishwarya for your gentle approach and professional expertise. The entire experience was comfortable and stress-free.",
    treatment: 'Tooth Extraction',
    verified: true,
    featured: false
  },
  {
    id: 13,
    name: 'Abhishek Pandey',
    rating: 5,
    date: '23 May 2020',
    review: "I ever seen loyal person like Dr. Aishwarya. She is very helpful in nature and genuinely cares about her patients. Her dedication to providing excellent care and her kind personality make her stand out. I'm grateful for her exceptional service and would highly recommend her to anyone.",
    treatment: 'General Care',
    verified: true,
    featured: false
  },
  {
    id: 14,
    name: 'A.M. Saravana Muthu Kumaran',
    rating: 5,
    date: '10 Mar 2020',
    review: "For someone who had had a spate of bad dentists all my life, Dr. V. Aishwarya at SRI SAI SABARI DENTAL CLINIC comes as a breath of fresh air. Her gentle approach, clear explanations, and painless treatments have restored my confidence in dental care. Excellent service and highly professional.",
    treatment: 'Comprehensive Care',
    verified: true,
    featured: false
  },
  {
    id: 15,
    name: 'Nirmal Raj',
    rating: 5,
    date: '30 Jan 2020',
    review: "Visiting a dentist for the first time in my life, was a unique experience. Having heard a lot of painful stories about dental treatments, I was quite apprehensive. But Dr. Aishwarya made the entire experience comfortable and painless. She explained everything clearly and made me feel at ease. Excellent first impression!",
    treatment: 'First Visit',
    verified: true,
    featured: false
  },
  {
    id: 16,
    name: 'Jagadeesh D',
    rating: 5,
    date: '31 Jan 2020',
    review: "The staff is very kind, helpful and knowledgeable and professional too. The office is clean and the staff is very friendly. Dr. Aishwarya provides excellent care with a personal touch. The entire team works together to ensure patient comfort and satisfaction. Highly recommended!",
    treatment: 'General Care',
    verified: true,
    featured: false
  },
  {
    id: 17,
    name: 'Arun Vishwa',
    rating: 5,
    date: '20 Jul 2019',
    review: "Being a wonderful hardworker the doctor makes the patient very comfortable and explain the process making us undergo the treatment without any fear. Dr. Aishwarya's dedication to patient care and her ability to explain procedures clearly make her exceptional. The treatment was smooth and comfortable.",
    treatment: 'Dental Treatment',
    verified: true,
    featured: false
  },
  {
    id: 18,
    name: 'Renu Prasath',
    rating: 5,
    date: '10 Jun 2019',
    review: "Dr. Aishwarya was very humble and the treatment procedure was explained well before it was done. The price was also very reasonable. Her humble nature and clear communication made the entire experience pleasant. The treatment was effective and the pricing is very fair. Highly satisfied!",
    treatment: 'Dental Treatment',
    verified: true,
    featured: false
  },
  {
    id: 19,
    name: 'Gokula Krishnan',
    rating: 5,
    date: '9 Jun 2019',
    review: "I'm completely satisfied with this clinic Doctor. She is so kind to me and explained full details about my teeth. Her treatment too very good and very professional. I'm healing very fast. Thank you Doctor. 😊 Dr. Aishwarya's professional approach and kind nature make her exceptional.",
    treatment: 'Dental Treatment',
    verified: true,
    featured: false
  },
  {
    id: 20,
    name: 'Harish Sankar',
    rating: 5,
    date: '15 Aug 2019',
    review: "I have teeth pain.. i didn't went to any dental clinic but when i saw this clinic page in Instagram they give offer. I took the offer and visited the clinic. Dr. Aishwarya treated me very well and solved my problem. Very satisfied with the service and would recommend to others.",
    treatment: 'Pain Relief',
    verified: true,
    featured: false
  }
]

const filterOptions = [
  'All Reviews',
  'Featured',
  'Root Canal',
  'Tooth Extraction',
  'General Care',
  'Emergency Treatment',
  'Pediatric Care'
]

export function TestimonialsPage() {
  const [selectedFilter, setSelectedFilter] = useState('All Reviews')
  const [showAll, setShowAll] = useState(false)

  const filteredTestimonials = selectedFilter === 'All Reviews' 
    ? testimonials
    : selectedFilter === 'Featured'
    ? testimonials.filter(t => t.featured)
    : testimonials.filter(t => t.treatment.toLowerCase().includes(selectedFilter.toLowerCase()))

  const displayedTestimonials = showAll ? filteredTestimonials : filteredTestimonials.slice(0, 9)

  const averageRating = testimonials.reduce((sum, t) => sum + t.rating, 0) / testimonials.length

  return (
    <div className="min-h-screen">
      <Header currentPage="testimonials" />

      {/* Hero Section */}
      <section className="bg-gradient-to-br from-black via-gray-900 to-black py-16 relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-r from-yellow-400/10 via-yellow-500/8 to-yellow-600/5 animate-pulse"></div>
        <div className="absolute inset-0">
          <div className="absolute top-10 left-10 w-20 h-20 bg-gradient-to-br from-yellow-400/20 to-yellow-600/15 rounded-full blur-xl animate-bounce" style={{animationDelay: '0s'}}></div>
          <div className="absolute top-1/2 right-20 w-16 h-16 bg-gradient-to-br from-yellow-500/15 to-yellow-700/10 rounded-full blur-lg animate-bounce" style={{animationDelay: '2s'}}></div>
        </div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="text-center">
            <h1 className="text-4xl md:text-5xl font-bold text-white mb-6 animate-fade-in-up" style={{animationDelay: '0.2s', animationFillMode: 'both'}}>
              Patient <span className="bg-gradient-to-r from-yellow-400 via-yellow-500 to-yellow-600 bg-clip-text text-transparent">Testimonials</span>
            </h1>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto mb-8 animate-fade-in-up" style={{animationDelay: '0.4s', animationFillMode: 'both'}}>
              Read what our patients say about their experience with Dr. Aishwarya V and our dental care services
            </p>
            <div className="flex items-center justify-center space-x-8 text-center animate-fade-in-up" style={{animationDelay: '0.6s', animationFillMode: 'both'}}>
              <div className="bg-white/10 backdrop-blur-sm border border-yellow-500/30 p-6 rounded-lg hover:bg-white/20 transition-all duration-300 min-h-[120px] flex flex-col justify-center">
                <div className="flex items-center justify-center mb-2">
                  {Array.from({ length: 5 }).map((_, i) => (
                    <Star key={i} className="h-6 w-6 text-yellow-400 fill-current" />
                  ))}
                </div>
                <p className="text-2xl font-bold text-white">{averageRating.toFixed(1)}/5</p>
                <p className="text-gray-300">Average Rating</p>
              </div>
              <div className="bg-white/10 backdrop-blur-sm border border-yellow-500/30 p-6 rounded-lg hover:bg-white/20 transition-all duration-300 min-h-[120px] flex flex-col justify-center">
                <div className="mb-2 h-6">
                  {/* Spacer for alignment with stars */}
                </div>
                <p className="text-2xl font-bold text-white">10000+</p>
                <p className="text-gray-300">Happy Patients</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Featured Testimonials */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">Featured Patient Stories</h2>
            <p className="text-xl text-gray-600">Transforming smiles and lives, one patient at a time</p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {testimonials.filter(t => t.featured).map((testimonial) => (
              <div key={testimonial.id} className="bg-white rounded-lg shadow-lg p-8 relative">
                <div className="absolute top-4 right-4">
                  <Quote className="h-8 w-8 text-yellow-200" />
                </div>
                <div className="flex items-center mb-4">
                  {Array.from({ length: testimonial.rating }).map((_, i) => (
                    <Star key={i} className="h-5 w-5 text-yellow-500 fill-current" />
                  ))}
                </div>
                <p className="text-gray-600 mb-6 italic">"{testimonial.review}"</p>
                <div className="flex items-center justify-between">
                  <div>
                    <h4 className="font-semibold text-gray-900">{testimonial.name}</h4>
                    <p className="text-sm text-gray-500">{testimonial.treatment}</p>
                  </div>
                  <div className="text-right">
                    <p className="text-sm text-gray-500">{testimonial.date}</p>
                    {testimonial.verified && (
                      <p className="text-sm text-green-600">✓ Verified</p>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* All Testimonials */}
      <section id="testimonials" className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col md:flex-row justify-between items-center mb-8">
            <h2 className="text-3xl font-bold text-gray-900 mb-4 md:mb-0">All Patient Reviews</h2>
            <div className="flex items-center space-x-4">
              <Filter className="h-5 w-5 text-gray-500" />
              <select
                value={selectedFilter}
                onChange={(e) => setSelectedFilter(e.target.value)}
                className="px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-yellow-500"
              >
                {filterOptions.map(option => (
                  <option key={option} value={option}>{option}</option>
                ))}
              </select>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {displayedTestimonials.map((testimonial) => (
              <div key={testimonial.id} className="bg-white rounded-lg shadow-sm p-6 hover:shadow-md transition-shadow">
                <div className="flex items-center justify-between mb-4">
                  <div className="flex items-center">
                    {Array.from({ length: testimonial.rating }).map((_, i) => (
                      <Star key={i} className="h-4 w-4 text-yellow-500 fill-current" />
                    ))}
                  </div>
                  <span className="text-sm text-gray-500">{testimonial.date}</span>
                </div>
                <p className="text-gray-600 mb-4 text-sm line-clamp-4">"{testimonial.review}"</p>
                <div className="flex items-center justify-between">
                  <div>
                    <h4 className="font-medium text-gray-900">{testimonial.name}</h4>
                    <p className="text-sm text-gray-500">{testimonial.treatment}</p>
                  </div>
                  {testimonial.verified && (
                    <div className="flex items-center text-green-600">
                      <ThumbsUp className="h-4 w-4 mr-1" />
                      <span className="text-sm">Verified</span>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>

          {!showAll && filteredTestimonials.length > 9 && (
            <div className="text-center mt-12">
              <Button
                onClick={() => setShowAll(true)}
                variant="outline"
                size="lg"
              >
                Show More Reviews ({filteredTestimonials.length - 9} more)
              </Button>
            </div>
          )}
        </div>
      </section>

      {/* Review Stats */}
      <section className="py-16 bg-gray-50 relative overflow-hidden">
        <div className="absolute inset-0">
          <div className="absolute top-1/4 left-10 w-32 h-32 bg-gradient-to-br from-yellow-300/10 via-yellow-400/8 to-yellow-500/6 rounded-full blur-2xl animate-float" style={{animationDelay: '1s'}}></div>
          <div className="absolute bottom-1/4 right-10 w-24 h-24 bg-gradient-to-br from-yellow-400/15 via-yellow-500/12 to-yellow-600/10 rounded-full blur-xl animate-float" style={{animationDelay: '3s'}}></div>
        </div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4 animate-fade-in-up hover:bg-gradient-to-r hover:from-yellow-600 hover:via-yellow-700 hover:to-yellow-800 hover:bg-clip-text hover:text-transparent transition-all duration-300" style={{animationDelay: '0.2s', animationFillMode: 'both'}}>Why Patients Choose Us</h2>
            <p className="text-xl text-gray-600 animate-fade-in-up" style={{animationDelay: '0.4s', animationFillMode: 'both'}}>Based on patient feedback and reviews</p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            <div className="bg-white/10 backdrop-blur-sm border border-yellow-500/30 p-6 rounded-lg hover:bg-white/20 transition-all duration-300 text-center animate-fade-in-up" style={{animationDelay: '0.6s', animationFillMode: 'both'}}>
              <div className="text-3xl font-bold bg-gradient-to-r from-yellow-600 via-yellow-700 to-yellow-800 bg-clip-text text-transparent mb-2">100%</div>
              <div className="text-gray-700">Painless Treatment</div>
            </div>
            <div className="bg-white/10 backdrop-blur-sm border border-yellow-500/30 p-6 rounded-lg hover:bg-white/20 transition-all duration-300 text-center animate-fade-in-up" style={{animationDelay: '0.7s', animationFillMode: 'both'}}>
              <div className="text-3xl font-bold bg-gradient-to-r from-yellow-600 via-yellow-700 to-yellow-800 bg-clip-text text-transparent mb-2">4.9/5</div>
              <div className="text-gray-700">Patient Satisfaction</div>
            </div>
            <div className="bg-white/10 backdrop-blur-sm border border-yellow-500/30 p-6 rounded-lg hover:bg-white/20 transition-all duration-300 text-center animate-fade-in-up" style={{animationDelay: '0.8s', animationFillMode: 'both'}}>
              <div className="text-3xl font-bold bg-gradient-to-r from-yellow-600 via-yellow-700 to-yellow-800 bg-clip-text text-transparent mb-2">10000+</div>
              <div className="text-gray-700">Happy Patients</div>
            </div>
            <div className="bg-white/10 backdrop-blur-sm border border-yellow-500/30 p-6 rounded-lg hover:bg-white/20 transition-all duration-300 text-center animate-fade-in-up" style={{animationDelay: '0.9s', animationFillMode: 'both'}}>
              <div className="text-3xl font-bold bg-gradient-to-r from-yellow-600 via-yellow-700 to-yellow-800 bg-clip-text text-transparent mb-2">7+ Years</div>
              <div className="text-gray-700">Professional Experience</div>
            </div>
          </div>
        </div>
      </section>

      {/* Leave Review CTA */}
      <section className="py-16 bg-gradient-to-br from-black via-gray-900 to-black text-white relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-r from-yellow-400/10 via-yellow-500/8 to-yellow-600/5 animate-pulse"></div>
        <div className="absolute inset-0">
          <div className="absolute top-1/4 left-1/4 w-32 h-32 bg-gradient-to-br from-yellow-300/10 via-yellow-400/8 to-yellow-500/6 rounded-full blur-2xl animate-float" style={{animationDelay: '1s'}}></div>
          <div className="absolute bottom-1/4 right-1/4 w-24 h-24 bg-gradient-to-br from-yellow-400/15 via-yellow-500/12 to-yellow-600/10 rounded-full blur-xl animate-float" style={{animationDelay: '3s'}}></div>
        </div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10">
          <h2 className="text-3xl font-bold mb-4">Share Your Experience</h2>
          <p className="text-xl mb-8">
            Had a great experience with Dr. Aishwarya? We'd love to hear from you!
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button asChild size="lg" variant="secondary">
              <a href="https://g.co/kgs/swqYX7W" target="_blank" rel="noopener noreferrer">
                <Star className="mr-2 h-5 w-5" />
                Leave a Google Review
              </a>
            </Button>
            <Button asChild size="lg" variant="outline" className="border-2 border-white text-yellow-400 hover:bg-white hover:text-yellow-600">
              <Link to="/book-appointment">
                <Calendar className="mr-2 h-5 w-5" />
                Book Your Appointment
              </Link>
            </Button>
          </div>
        </div>
      </section>

      {/* Personal Message from Dr. Aishwarya */}
      <section className="py-16 bg-yellow-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white rounded-2xl shadow-lg p-8 md:p-12">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
              <div className="text-center lg:text-left">
                <h2 className="text-3xl font-bold text-gray-900 mb-6">A Personal Message</h2>
                <blockquote className="text-lg text-gray-600 mb-6 italic">
                  "Thank you for trusting me with your dental care. Each positive review and happy smile motivates me to continue providing the best possible treatment with compassion and excellence. Your oral health is my priority, and I'm honored to be part of your journey to a healthier, more confident smile."
                </blockquote>
                <div className="border-t pt-6">
                  <p className="text-xl font-semibold text-gray-900">Dr. Aishwarya V</p>
                  <p className="text-gray-600">BDS, FAAD (Germany)</p>
                  <p className="text-sm text-gray-500 mt-1">TN Dental Council Reg: 26411</p>
                  <p className="text-sm text-gray-500 mt-2">Sri Sai Sabari Dental Clinic</p>
                </div>
              </div>
              <div className="text-center">
                <div className="w-56 h-56 mx-auto">
                  <img 
                    src={drAishwaryaImage} 
                    alt="Dr. Aishwarya V - Thank you message to patients at Sri Sai Sabari Dental Clinic"
                    className="w-full h-full object-cover rounded-full shadow-xl border-4 border-yellow-100"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  )
}